import { TagVariant } from "@/components/ui/tag"
import {
  de_BetterDocExchangeOutcome,
  de_BetterDocRemoteRequestStatus,
  de_BetterDocSessionStepType,
  de_BetterDocTestCaseOutcome,
} from "@/types/__generated__/union-types"

export const EXCHANGE_OUTCOME_TAG_VARIANTS: Record<de_BetterDocExchangeOutcome, TagVariant> = {
  PENDING: "warning",
  RESPONDED: "neutral",
  TIMED_OUT: "critical",
  CANCELLED: "warning",
  TOKEN_UNAVAILABLE: "critical",
  FAILED: "critical",
}

export const TEST_CASE_OUTCOME_TAG_VARIANTS: Record<de_BetterDocTestCaseOutcome, TagVariant> = {
  PMN_RECEIVED: "success",
  MSN_PENDING: "success",
  NO_NAVIGATION: "success",
  EXISTING_RECOMMENDATION: "success",
  REQUEST_FAILED: "critical",
  UNEXPECTED_RESPONSE: "critical",
}

export const REMOTE_REQUEST_STATUS_TAG_VARIANTS: Record<de_BetterDocRemoteRequestStatus, TagVariant> = {
  RECEIVED: "success",
  INVALID_RECOMMENDATION_ID: "critical",
  NOT_FOUND: "warning",
  REQUEST_FAILED: "critical",
  UNEXPECTED_RESPONSE: "critical",
}

export const FAILURE_STEP_TYPES: ReadonlyArray<de_BetterDocSessionStepType> = [
  "REQUEST_FAILED",
  "CREDENTIALS_REJECTED",
  "VALIDATION_REJECTED",
  "RATE_LIMITED",
  "RECOMMENDATION_NOT_FOUND",
  "UNEXPECTED_RESPONSE",
]
